import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/inherits";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { RecognitionResult } from "./Exports";
/**
 * Defines result of speech recognition.
 * @class SpeechRecognitionResult
 */

export var SpeechRecognitionResult = /*#__PURE__*/function (_RecognitionResult) {
  _inherits(SpeechRecognitionResult, _RecognitionResult);

  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @public
   * @param {string} resultId - The result id.
   * @param {ResultReason} reason - The reason.
   * @param {string} text - The recognized text.
   * @param {number} duration - The duration.
   * @param {number} offset - The offset into the stream.
   * @param {string} errorDetails - Error details, if provided.
   * @param {string} json - Additional Json, if provided.
   * @param {PropertyCollection} properties - Additional properties, if provided.
   */
  function SpeechRecognitionResult(resultId, reason, text, duration, offset, errorDetails, json, properties) {
    _classCallCheck(this, SpeechRecognitionResult);

    return _possibleConstructorReturn(this, _getPrototypeOf(SpeechRecognitionResult).call(this, resultId, reason, text, duration, offset, errorDetails, json, properties));
  }

  return SpeechRecognitionResult;
}(RecognitionResult);